// src/stone/icons/SecurityKey.tsx
import { jsx } from "react/jsx-runtime";
var SecurityKey = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M7.5 22s-.1 0 0 0c-.9 0-1.7-.2-2.5-.5s-1.5-.8-2.1-1.4C1.6 18.8 1 17.2 1 15.5s.7-3.3 1.9-4.5 2.8-1.9 4.5-1.9c1.4 0 2.7.4 3.8 1.2l3.5-3.5 5.5-5.5c.4-.4 1-.4 1.4 0 .2.2.3.5.3.7s-.1.5-.3.7L20.3 4l2.3 2.3c.4.4.4 1 0 1.4l-3.5 3.5c-.4.4-1 .4-1.4 0l-2.3-2.3-2.7 2.7c.3.4.6.9.8 1.3.3.8.5 1.6.5 2.5s-.2 1.7-.5 2.5-.8 1.5-1.4 2.1-1.3 1.1-2.1 1.4c-.9.5-1.7.6-2.5.6m0-10.9c-1.2 0-2.3.5-3.2 1.3-.8.8-1.3 2-1.3 3.1 0 1.2.4 2.3 1.3 3.2.4.4.9.7 1.5 1 .5.2 1 .3 1.6.3s1.2-.1 1.7-.3c.6-.2 1-.6 1.5-1 .4-.4.8-.9 1-1.5s.3-1.1.3-1.7-.1-1.2-.4-1.7c-.2-.5-.6-1-1-1.5-.7-.8-1.8-1.2-3-1.2m9.3-3.6 1.6 1.6L20.5 7l-1.6-1.6z" })
  }
);
var SecurityKey_default = SecurityKey;

export {
  SecurityKey,
  SecurityKey_default
};
